const typography = {
  family: 'Poppins',
  size: {
    text: '0.875rem',
  },
};

export default typography;
